import { WorkspaceTypeEnum } from '@sr-sdks/api-sdk-axios';
import * as yup from 'yup';

export const paymentRuleSchema = yup.object({
  client: yup.object().shape({
    key: yup.string(),
    value: yup.string().when(['workspaceType'], ([workspaceType], schema) => {
      if (workspaceType === WorkspaceTypeEnum.BusinessAgency)
        return schema.required('Please Select a Client');

      return schema.nullable();
    }),
  }),
  serviceType: yup.object().shape({
    key: yup.string().required('Please select a Service'),
    value: yup.string().required('Please select a Service'),
  }),
  title: yup.object().shape({
    key: yup.string().required('Please select a Title'),
    value: yup.string().required('Please select a Title'),
  }),
  workspaceType: yup.string(),
});
